/* @flow */

import React from 'react';
import Relay from 'react-relay';

import { style, merge } from 'glamor';

import { isEqual, debounce } from 'lodash';

import Linear from 'depop/components/loaders/Linear';

function cleanFormats(formats) {
  return formats.map(format => ({
    size: format.width,
    url: format.url,
  }));
}

class Picture extends React.PureComponent {
  props: {
    picture: Object,
    lazyloadOffset: number,
    scrollDelay: number,
    title: string,
    alt: string,
    rounded: boolean,
    useLoader: boolean,
  };

  state: {
    mounted: boolean,
  };

  static defaultProps = {
    rounded: false,
    useLoader: false,
    lazyloadOffset: 0,
    scrollDelay: 250,
  };

  constructor(props) {
    super(props);
    this.loadImage = debounce(this.loadImage, 250, {leading: true});
    this.state = {mounted: false};
  }

  loadImage = () => {
    window.loadImage(this._imgContainer);
  };

  componentWillReceiveProps(nextProps) {
    const cleanedFormats = cleanFormats(this.props.picture.formats);
    const nextCleanedFormats = cleanFormats(nextProps.picture.formats);

    if (!isEqual(cleanedFormats, nextCleanedFormats)) {
      if (this && this._imgContainer) {
        this._imgContainer.innerHTML = '';
      }
    }
  }

  componentDidUpdate() {
    window.loadImage(this._imgContainer);
  }

  componentDidMount() {
    this.setState({mounted: true});
    this.loadImage();
    window.addEventListener('resize', this.loadImage);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.loadImage);
  }

  render() {
    const { picture, rounded, useLoader } = this.props;
    const ratio = picture.width / picture.height;
    const heightPercentage = 100 * ratio;

    const baseWrapperStyles = style({
      backgroundColor: '#eee',
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
    });

    const wrapperStyles = rounded
      ? merge(baseWrapperStyles, style({borderRadius: '50%'}))
      : baseWrapperStyles;

    const baseImageStyles = style({
      '> img': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        verticalAlign: 'bottom',
        display: 'block',
      },
    });

    const imageStyles = rounded
      ? merge(baseImageStyles, style({
        '> img': { borderRadius: '50%' },
      }))
      : baseImageStyles;

    return (
      <div {...wrapperStyles} style={{paddingBottom: `${heightPercentage}%`}}>
        {useLoader && this.state.mounted && <div {...style({
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })}><Linear /></div>}
        <div {...imageStyles} ref={element => this._imgContainer = element}
          data-picture
          data-formats={JSON.stringify(cleanFormats(picture.formats))} />
      </div>
    );
  }
}

export default Relay.createContainer(Picture, {
  fragments: {
    picture: () => Relay.QL`
      fragment on Picture {
        url
        width
        height
        formats {
          url
          width
          height
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/images/Picture.js